import React, { useState } from 'react';
import SpinnerLoad from 'views/finance/moduleComponents/SpinnerLoad';

// ###### COMPONENT
const CardPluggyConnection = ({
  clientId,
  clientSecret,
  items,
  loading,
  setLoading,
  getPluggyApiToken
}) => {
  const [tokenMessage, setTokenMessage] = useState('');

  const handleGetToken = async () => {
    try {
      setLoading(prev => ({ ...prev, token: true }));
      const token = await getPluggyApiToken();
      setTokenMessage(`API token successfully received: ${token}`);
    } catch (err) {
      setTokenMessage('Error retrieving API token.');
      console.error(err);
    } finally {
      setLoading(prev => ({ ...prev, token: false }));
    }
  };

  return (
    <div className="bg-white p-6 rounded-2xl shadow flex-1">
      {/* Provider Selection Tabs */}
      <div className="flex items-center justify-center mb-6">
        <div className="bg-gray-100 rounded-full p-1 inline-flex">
          <button
            className="px-6 py-2 text-sm font-medium rounded-full transition-all bg-green-800 text-white shadow-sm"
          >
            Pluggy
          </button>
          <button
            disabled
            className="px-6 py-2 text-sm font-medium rounded-full transition-all text-gray-400 cursor-not-allowed"
          >
            Belvo
          </button>
        </div>
      </div>

      <h2 className="text-xl font-semibold">Pluggy Connection</h2>
      <div className="mt-4 flex flex-col gap-4">
        <div>
          <h3 className="text-md font-semibold">Pluggy Credentials:</h3>
          {loading.credentials ? (
            <SpinnerLoad />
          ) : (
            <>
              <p className="text-sm text-gray-700">Client ID: <span className="font-mono">{clientId || '–'}</span></p>
              <p className="text-sm text-gray-700">Client Secret: <span className="font-mono">{clientSecret || '–'}</span></p>
            </>
          )}
        </div>

        <div>
          <h3 className="text-md font-semibold mt-2">Available Finance Items:</h3>
          {loading.items ? (
            <SpinnerLoad />
          ) : items.length > 0 ? (
            <ul className="list-disc list-inside text-sm text-gray-700 mt-1">
              {items.map((item) => (
                <li key={item.item_id}>
                  {item.institution} – {item.item_id}
                </li>
              ))}
            </ul>
          ) : (
            <p className="text-sm text-gray-500">no finance item registered for this user</p>
          )}
        </div>

        <button onClick={handleGetToken} className="bg-green-800 text-white px-4 py-2 rounded-lg w-fit">
          {loading.token ? 'Getting token...' : 'Get API Token'}
        </button>
        {tokenMessage && <p className="text-green-700">{tokenMessage}</p>}
      </div>
    </div>
  );
};

export default CardPluggyConnection;
